import { BurgerMenuSectionType } from '../types/BurgerMenu';

const origin = (window?.location?.origin ?? '').replace('https://', '');

export const SECTIONS: BurgerMenuSectionType[] = [
    {
        title: 'OwwHeader_Menu',
        dataTestId: 'oww-header-burger-menu-main',
        items: [
            {
                label: 'app',
                title: 'OwwHeader_Download Westwing App',
                link: '#',
                dataNoOverlay: true,
                dataTestId: 'oww-header-burger-menu-main-app',
            },
            {
                label: 'cop',
                title: 'OwwHeader_Current Sales',
                link: '/c/campaign',
                dataTestId: 'oww-header-burger-menu-main-cop',
            },
            {
                label: 'cup',
                title: 'OwwHeader_Upcoming Sales',
                link: '/c/campaign/upcoming',
                dataTestId: 'oww-header-burger-menu-main-cup',
            },
            {
                label: 'wws',
                title: 'OwwHeader_Interior Beratung',
                link: '/m/westwingstudio?utm_source=club&utm_medium=mobilemenu&utm_campaign=ids_club_mobile_menu_entry',
            },
            {
                label: 'raf',
                title: 'OwwHeader_Invite a friend',
                link: '/c/customer/invitation/create/',
                dataTestId: 'oww-header-burger-menu-main-raf',
            },
            {
                label: 'gift',
                title: 'OwwHeader_Gift Vouchers',
                link: '#',
            },
            {
                label: 'inspiration',
                title: 'OwwHeader_#MyWestwingStyle',
                link: '/m/ugcgallery/',
                dataTestId: 'oww-header-burger-menu-main-inspiration',
            },
            {
                label: 'shop',
                title: 'OwwHeader_Go to WestwingNow',
                link: `/?utm_source=${origin}&utm_medium=referral&utm_campaign=club-shop-tab`,
            },
        ],
    },
    {
        onlyForLoggedInUsers: true,
        title: 'OwwHeader_My account',
        dataTestId: 'oww-header-burger-menu-my-account',
        items: [
            {
                title: 'OwwHeader_My orders',
                link: '/c/customer/order/index/',
                dataTestId: 'oww-header-burger-menu-my-account-orders',
            },
            {
                title: 'OwwHeader_My Credentials',
                link: '/c/customer/account/index/',
                dataTestId: 'oww-header-burger-menu-my-account-credentials',
            },
            {
                title: 'OwwHeader_My coupons',
                link: '/c/customer/coupon/index/',
            },
            {
                title: 'OwwHeader_My Newsletters',
                link: '/c/customer/newsletter/index/',
                dataTestId: 'oww-header-burger-menu-my-account-newsletter',
            },
            {
                title: 'OwwHeader_My Notifications',
                link: '/c/customer/notification/',
            },
            {
                title: 'OwwHeader_Logout',
                link: '/c/customer/account/logout/',
                id: 'logout',
                dataTestId: 'oww-header-burger-menu-my-account-logout',
            },
        ],
    },
    {
        title: 'OwwHeader_Service',
        dataTestId: 'oww-header-burger-menu-service',
        items: [
            {
                title: 'OwwHeader_Phone Number',
                linkTitle: 'OwwHeader_Phone Number',
                link: 'OwwHeader_Phone Number',
                tel: true,
                dataNoOverlay: true,
                dataTestId: 'oww-header-burger-menu-service-phone',
            },
            {
                title: 'OwwHeader_Help & Contact',
                link: '/c/helpcenter/',
                dataNoOverlay: true,
                dataTestId: 'oww-header-burger-menu-service-help',
            },
        ],
    },
];
